<template>
    <La1 :ratio="'1fr 1fr'" id="menucategory" :popupL="popupL" :popupR="popup" :style="{gap: 0}">
      <template slot="left">
        <div class="title1">
          <div>套餐類別
            <SBtn :bg="'var(--color-checked)'" :icon="'sort'"  :text="'排序'" v-if="!sortSet" @click="sortSet=true"/>
            <SBtn :bg="'#E37878'" :icon="'sort'"  :text="'確定'" v-else @click="updateSetSort"/>
          </div>
          <RBtn @click="popupL='cate'" :bg="'var(--color-checked)'" :icon="'add'" :text="'新增套餐類別'"/>
        </div>
        <Draggable class="body1" v-model="setcates" v-if="sortSet">
          <div v-for="(item, i) in setcates" :key="`set-${i}`" class="cate">
            <div :style="item.image?{backgroundImage: `url(.${item.image})`}:{}"></div>
            <div>{{item.name}}</div>
          </div>
        </Draggable>
        <div class="body1" v-else>
          <div v-for="(item, i) in setcates" :key="`set-${i}`" class="cate">
            <div :style="item.image?{backgroundImage: `url(.${item.image})`}:{}"></div>
            <div>{{item.name}}</div>
            <div class="cover">
              <EditBtn @click="set=JSON.parse(JSON.stringify(item));updateSetIndex=i;popupL='cate';" class="editzxc"/>
              <DelBtn @click="delOneSet(i)" class="delbtnzxc"/>
            </div>
          </div>
        </div>
        <div class="title1" :style="{marginTop: '40px'}">
          <div>套餐橫幅</div>
          <RBtn @click="popupL='banner'" :bg="'var(--color-checked)'" :icon="'add'" :text="'新增套餐橫幅'"/>
        </div>
        <div class="body1">
          <div v-for="(item, i) in setbanners" :key="`set-${i}`" class="banner">
            <div :style="item.image?{backgroundImage: `url(.${item.image})`}:{}"></div>
            <div>{{item.name}}</div>
            <div class="cover">
              <EditBtn @click="set=JSON.parse(JSON.stringify(item));updateSetBIndex=i;popupL='banner';" class="editzxc"/>
              <DelBtn @click="delOneSetB(i)" class="delbtnzxc"/>
            </div>
          </div>
        </div>
      </template>
      <template>
        <div class="title1" >
          <div>單點類別 <SBtn :bg="'var(--color-checked)'" :icon="'sort'" :text="'排序'" v-if="!sortProd" @click="sortProd=true"/>
          <SBtn :bg="'#E37878'" :icon="'sort'"  :text="'確定'" v-else @click="updateProdSort"/></div>
          <RBtn @click="popup='cate'" :bg="'var(--color-checked)'" :icon="'add'" :text="'新增單點類別'"/>
        </div>
        <Draggable class="body1" v-model="prodcates" v-if="sortProd">
          <div v-for="(item, i) in prodcates" :key="`prod-${i}`" class="cate">
            <div :style="item.image?{backgroundImage: `url(.${item.image})`}:{}"></div>
            <div>{{item.name}}</div>
          </div>
        </Draggable>
        <div class="body1" v-else>
          <div v-for="(item, i) in prodcates" :key="`prod-${i}`" class="cate">
            <div :style="item.image?{backgroundImage: `url(.${item.image})`}:{}"></div>
            <div>{{item.name}}</div>
            <div class="cover">
              <EditBtn @click="prod=JSON.parse(JSON.stringify(item));updateProdIndex=i;popup='cate';" class="editzxc"/>
              <DelBtn @click="delOneProd(i)" class="delbtnzxc"/>
            </div>
          </div>
        </div>
        <div class="title1" :style="{marginTop: '40px'}">
          <div>單點橫幅 </div>
          <RBtn @click="popup='banner'" :bg="'var(--color-checked)'" :icon="'add'" :text="'新增單點橫幅'"/>
        </div>
        <div class="body1">
          <div v-for="(item, i) in prodbanners" :key="`prod-${i}`" class="banner">
            <div :style="item.image?{backgroundImage: `url(.${item.image})`}:{}"></div>
            <div>{{item.name}}</div>
            <div class="cover">
              <EditBtn @click="prod=JSON.parse(JSON.stringify(item));updateProdBIndex=i;popup='banner';" class="editzxc"/>
              <DelBtn @click="delOneProdB(i)" class="delbtnzxc"/>
            </div>
          </div>
        </div>
      </template>
      <template slot="popupL">
        <DialogDef2 :show="popupL==='cate'&&updateSetIndex===null" :style="{left: 0}" :label="'新增套餐類別'" :width="'510px'" :height="'365px'" @close="popupL=null;set={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'category'" :defaultValue="set.image" @input="set.image=$event"/>
          <input type="text" placeholder="請輸入套餐類別名稱" v-model="set.name">
          <Btns @cancel="popupL=null;set={name:null,image:null};" @save="updateSet('setcates', 'set-categories', 'updateSetIndex', 'set', 'popupL')"/>
        </div>
      </DialogDef2>
        <DialogDef2 :show="popupL==='cate'&&updateSetIndex!==null" :style="{left: 0}" :label="'編輯套餐類別'" :width="'510px'" :height="'365px'" @close="popupL=null;set={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'category'" :defaultValue="set.image" @input="set.image=$event"/>
          <input type="text" placeholder="請輸入套餐類別名稱" v-model="set.name">
          <Btns @cancel="popupL=null;set={name:null,image:null};" @save="updateSet('setcates', 'set-categories', 'updateSetIndex', 'set', 'popupL')"/>
        </div>
      </DialogDef2>
        <DialogDef2 :show="popupL==='banner'&&updateSetBIndex===null" :style="{left: 0}" :label="'新增套餐橫幅'" :width="'510px'" :height="'365px'" @close="popupL=null;set={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'banner'" :defaultValue="set.image" @input="set.image=$event"  :style="{width: '331px', height: '212px'}"/>
          <input type="text" placeholder="請輸入套餐橫幅名稱" v-model="set.name">
          <Btns @cancel="popupL=null;set={name:null,image:null};" @save="updateSet('setbanners', 'set-banners', 'updateSetBIndex', 'set', 'popupL')"/>
        </div>
      </DialogDef2>
        <DialogDef2 :show="popupL==='banner'&&updateSetBIndex!==null" :style="{left: 0}" :label="'編輯套餐橫幅'" :width="'510px'" :height="'365px'" @close="popupL=null;set={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'banner'" :defaultValue="set.image" @input="set.image=$event" :style="{width: '331px', height: '212px'}"/>
          <input type="text" placeholder="請輸入套餐橫幅名稱" v-model="set.name">
          <Btns @cancel="popupL=null;set={name:null,image:null};" @save="updateSet('setbanners', 'set-banners', 'updateSetBIndex', 'set', 'popupL')"/>
        </div>
      </DialogDef2>
      </template>
      <template slot="popupR">
        <DialogDef2 :show="popup==='cate'&&updateProdIndex===null" :style="{left: 0}" :label="'新增單點類別'" :width="'510px'" :height="'365px'" @close="popup=null;prod={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'category'" :defaultValue="prod.image" @input="prod.image=$event"/>
          <input type="text" placeholder="請輸入單點類別名稱" v-model="prod.name" :style="{marginInline: 'auto'}">
          <Btns @cancel="popup=null;prod={name:null,image:null};" @save="updateSet('prodcates', 'prod-categories', 'updateProdIndex', 'prod', 'popup')"/>
        </div>
      </DialogDef2>
        <DialogDef2 :show="popup==='cate'&&updateProdIndex!==null" :style="{left: 0}" :label="'編輯單點類別'" :width="'510px'" :height="'365px'" @close="popup=null;prod={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'category'" :defaultValue="prod.image" @input="prod.image=$event"/>
          <input type="text" placeholder="請輸入單點類別名稱" v-model="prod.name" :style="{marginInline: 'auto'}">
          <Btns @cancel="popup=null;prod={name:null,image:null};" @save="updateSet('prodcates', 'prod-categories', 'updateProdIndex', 'prod', 'popup')"/>
        </div>
      </DialogDef2>
        <DialogDef2 :show="popup==='banner'&&updateProdBIndex===null" :style="{left: 0}" :label="'新增單點橫幅'" :width="'510px'" :height="'365px'" @close="popup=null;prod={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'banner'" :defaultValue="prod.image" @input="prod.image=$event" :style="{width: '331px', height: '212px'}"/>
          <input type="text" placeholder="請輸入單點橫幅名稱" v-model="prod.name" :style="{marginInline: 'auto'}">
          <Btns @cancel="popup=null;prod={name:null,image:null};" @save="updateSet('prodbanners', 'prod-banners', 'updateProdBIndex', 'prod', 'popup')"/>
        </div>
      </DialogDef2>
        <DialogDef2 :show="popup==='banner'&&updateProdBIndex!==null" :style="{left: 0}" :label="'編輯單點橫幅'" :width="'510px'" :height="'365px'" @close="popup=null;prod={name:null,image:null};">
        <div :style="{
          padding: '20px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }">
          <File :folder="'banner'" :defaultValue="prod.image" @input="prod.image=$event" :style="{width: '331px', height: '212px'}"/>
          <input type="text" placeholder="請輸入單點橫幅名稱" v-model="prod.name" :style="{marginInline: 'auto'}">
          <Btns @cancel="popup=null;prod={name:null,image:null};" @save="updateSet('prodbanners', 'prod-banners', 'updateProdBIndex', 'prod', 'popup')"/>
        </div>
      </DialogDef2>
      </template>
    </La1>
</template>

<script>
import EditBtn from '../../components/btn/edit.vue'
import DelBtn from '../../components/btn/del.vue'
import Btns from '../../components/btn/btns.vue'
import File from '../../components/input/file_cate.vue'
import Draggable from 'vuedraggable'
import RBtn from '../../components/btn/round.vue'
import SBtn from '../../components/btn/sqr40016.vue'
import La1 from '../../components/layout/La1.vue'
import { getapi, postapi } from '../../store/fetch'
export default {
  components: {
    La1,
    RBtn,
    Draggable,
    File,
    EditBtn,
    DelBtn,
    Btns,
    SBtn
  },
  data () {
    return {
      updateProdBIndex: null,
      updateSetBIndex: null,
      updateProdIndex: null,
      updateSetIndex: null,
      sortSetB: false,
      sortProdB: false,
      sortSet: false,
      sortProd: false,
      popupL: false,
      popup: false,
      setcates: [],
      prodcates: [],
      setbanners: [],
      prodbanners: [],
      set: {
        image: null,
        name: null
      },
      prod: {
        image: null,
        name: null
      }
    }
  },
  async mounted () {
    const t = await getapi('selections/set-categories')
    this.setcates = t
    const tp = await getapi('selections/prod-categories')
    this.prodcates = tp
    const banner = await getapi('selections/set-banners')
    this.setbanners = banner || []
    const bannerP = await getapi('selections/prod-banners')
    this.prodbanners = bannerP || []
  },
  methods: {
    async delOneSetB (index) {
      const data = JSON.parse(JSON.stringify(this.setbanners))
      data.splice(index, 1)
      const r = await postapi('selections/set-banners', { data })
      if (r) {
        this.popupL = false
        this.setbanners = r
      }
    },
    async delOneProdB (index) {
      const data = JSON.parse(JSON.stringify(this.prodbanners))
      data.splice(index, 1)
      const r = await postapi('selections/prod-banners', { data })
      if (r) {
        this.popup = false
        this.prodbanners = r
      }
    },
    async delOneSet (index) {
      const data = JSON.parse(JSON.stringify(this.setcates))
      data.splice(index, 1)
      const r = await postapi('selections/set-categories', { data })
      if (r) {
        this.popupL = false
        this.setcates = r
      }
    },
    async delOneProd (index) {
      const data = JSON.parse(JSON.stringify(this.prodcates))
      data.splice(index, 1)
      const r = await postapi('selections/prod-categories', { data })
      if (r) {
        this.popup = false
        this.prodcates = r
      }
    },
    async updateSetSort () {
      const r = await postapi('selections/set-categories', {
        data: this.setcates
      })
      if (r) {
        this.sortSet = false
        this.setcates = r
      }
    },
    async updateProdSort () {
      const r = await postapi('selections/prod-categories', {
        data: this.prodcates
      })
      if (r) {
        this.sortProd = false
        this.prodcates = r
      }
    },
    async updateSet (key1, key2, key3, key4, key5) {
      let data = JSON.parse(JSON.stringify(this[key1]))
      if (this[key3] === null) {
        data = data.concat(this[key4])
      } else {
        data.splice(this[key3], 1, this[key4])
      }
      const r = await postapi(`selections/${key2}`, { data })
      if (r) {
        this[key5] = false
        this[key3] = null
        this[key4] = {
          name: null,
          image: null
        }
        this[key1] = r
      }
    }
  }
}
</script>

<style lang="scss">
#menucategory {
  .La1_left {
    border-right: 1px solid #B9B9B9;
  }
  .La1_left, .La1_right {
    padding: 27px 42px;
    overflow-y: auto;
  }
  .editzxc {
    position: absolute;
    right: 11px;
    top: 9px;
    width: 25px;
    height: 25px;
    z-index: 3;
  }
  .delbtnzxc {
    position: absolute;
    bottom: 10px;
    left: 66px;
    width: 40px;
    height: 40px;
    right: 0;
    z-index: 3;
  }
  .banner {
    .delbtnzxc {
      position: absolute;
      bottom: 10px;
      left: 148px;
      width: 40px;
      height: 40px;
      right: 0;
      z-index: 3;
    }
    .editzxc {
      position: absolute;
      right: 11px;
      top: 9px;
      width: 32px;
      height: 32px;
      z-index: 3;
    }
  }
  .delbtnzxc>svg>path {
    fill: #FFFFFF;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
input[type=text] {
  width: 350px;
  height: 45px;
  border: 1px solid #848484;
  border-radius: 3px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
}
.body1 {
  margin-top: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px 27px;
  flex-wrap: wrap;
}
.cate {
  padding-block: 15px;
  width: 175px;
  height: 150px;
  border: 1px solid #C4C4C4;
  border-radius: 10px;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-checked);
  position: relative;
  z-index: 1;
  &>div:nth-child(1) {
    height: 90px;
    background-image: url(/iconSvg/category.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  &>.cover {
    z-index: 2;
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(165, 165, 165, 0.5);
    backdrop-filter: blur(2.5px);
  }
  &:hover>.cover {
    display: block;
  }
}
.banner {
  padding-block: 15px;
  width: 331px;
  height: 272px;
  // border: 1px solid #C4C4C4;
  // border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-checked);
  position: relative;
  z-index: 1;
  &>div:nth-child(1) {
    height: 212px;
    background-image: url(/iconSvg/category.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  &>.cover {
    z-index: 2;
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(165, 165, 165, 0.5);
    backdrop-filter: blur(2.5px);
  }
  &:hover>.cover {
    display: block;
  }
}
.title1 {
  display: flex;
  width: 100%;
  flex: 1;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &>div{
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
</style>
